import cn from 'classnames';
import { ButtonHTMLAttributes, ReactElement } from 'react';

export interface BaseButtonProps {
  text?: string;
  additionalClass?: string;
  disabled?: boolean;
  icon?: ReactElement;
  iconPosition?: 'left' | 'right';
  variant?:
    | 'primary'
    | 'success'
    | 'secondary'
    | 'danger'
    | 'info'
    | 'light'
    | 'warning'
    | 'light-primary'
    | 'light-secondary';
  variantType?: 'filled' | 'outlined';
  size?: 'sm' | 'md' | 'lg';
}

export interface ButtonProps extends BaseButtonProps {
  type?: ButtonHTMLAttributes<HTMLButtonElement>['type'];
  onClick?: () => void;
  isLoading?: boolean;
}

export const Button = ({
  text = 'Button',
  additionalClass,
  icon,
  iconPosition = 'left',
  type = 'button',
  disabled,
  isLoading,
  onClick,
  variant = 'primary',
  variantType = 'filled',
  size = 'md'
}: ButtonProps) => {
  const buttonClasses = cn(
    'btn',
    `btn${variantType === 'outlined' ? '-outline' : ''}-${variant}`,
    {
      'btn-sm': size === 'sm',
      'btn-lg': size === 'lg',
      disabled: disabled || isLoading
    },
    additionalClass
  );

  return (
    <button className={buttonClasses} type={type} onClick={onClick} disabled={disabled || isLoading}>
      {(icon || isLoading) && (
        <span className={cn({ 'me-2': iconPosition === 'left', 'ms-2': iconPosition === 'right' })}>
          {isLoading ? <span className="spinner-border spinner-border-sm" role="status" aria-hidden="true" /> : icon}
        </span>
      )}
      {text}
    </button>
  );
};
